import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearAll, clearResetBot, onAddEvaluation, onGetAdditionalDocuments, onGetEvaluations, setCertificateDetails, setErrorMessageNotapUser, setEvalDetails, setLoadingNotapUser, showCommentRichTextFormFunc, showDocumentCarouselFunc, showEvaluationDetailsFunc, showPrevCertificateDetailsFunc, showSendEvalFormFunc } from '../../../../config/redux/slice/notapUserSlice'
import { getRequest, postRequest } from '../../../../helpers/request'
import { appApi } from '../../../../utils/endpoints/appApi'
import DocumentCarousel from '../DocumentCarousel'
import NotapWrapper from '../../../layout/NotapWrapper'
import { DataTableWrapper } from '../../../components'
import AddCommentDrawer from './AddCommentDrawer'
import { evaluationDatatable, previousEvaluationDatatable } from '../../../../helpers/dataTables'
import { useNavigate } from 'react-router-dom'
import SendEvalModal from './SendEvalModal'
import StatusChangeConfirmation from './StatusChangeConfirmation'
import EvaluationDetails from './EvaluationDetails'
import AddEvaluationModal from './AddEvaluationModal'
import { setCertificateDetailsGeneral } from '../../../../config/redux/slice/appSlice'
import ViewCetrificateDetailsModal from './ViewCetrificateDetailsModal'

export default function PreviousEvaluationHistory() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
        token,
        userData
    } = useSelector((state) => state.authData)
    const {
        currencies,
        isRefreshed
    } = useSelector((state) => state.app)
    const {
        notapUserLoading,
        notapUserErrorMsg,
        notapUserSuccessMsg,
        certificateManagement:{certificateDetails, showPrevCertificateDetails, previousCertificateDetails, previousCertificateRequest, showStatusChangeConfirmation},
        evaluationManagement: {showCommentRichTextForm, showEvaluationDetails, showDocumentCarousel, showSendEvalForm, newData, hasBeenSent, evaluationDetails, evaluationsData}
    } = useSelector((state) => state.notapUser)
  useEffect(()=>{
    dispatch(clearAll({}))
    getSingleCertificate()
    previousEvaluationDatatable(evaluationsData,setDetails)
    getEvaluationHistory()
    getAdditionalDocs()
  }, [])


  const getSingleCertificate = async () =>{
      const res = await getRequest(
        token,
        `${appApi.getSingleCertificate(previousCertificateRequest?.certificate_id)}`,
        {},
        dispatch,
        "",
        "",
        ""
      )
      if(res != undefined && res.status < 400){
        // dispatch(setCertificateDetailsGeneral({details: res.data.data, modal: false}))
        dispatch(setCertificateDetails({details: certificateDetails, previous: res.data.data, modal: false}))
      }
    }

  const getEvaluationHistory = async () =>{
      dispatch(clearAll({}))
      const data = {
        certificate_id: previousCertificateRequest?.certificate_id
      }
      const res = await postRequest(
        token,
        `${appApi.getEvaluationHistory}`,
        data,
        dispatch,
        setLoadingNotapUser,
        onGetEvaluations,
        setErrorMessageNotapUser
      )
    }

    const setDetails = (data, type) => {
      // dispatch(setCertificateDetails({details: data, modal: true}))
      // dispatch(setCertificateDetailsGeneral({details: data, modal: true}))
      dispatch(setEvalDetails({details: data}))
      if(type == 'eval-details'){
        dispatch(showEvaluationDetailsFunc({modal: true}))
        // dispatch(showSendEvalFormFunc({modal: true, status: 'sent', evalId: data.ID }))
      }
    }

    const getAdditionalDocs = async () =>{
      const res = await getRequest(
        token,
        `${appApi.getAdditionalDocuments(previousCertificateRequest?.certificate_id)}`,
        {},
        dispatch,
        "",
        onGetAdditionalDocuments,
        ""
      )
    }

    useEffect(()=>{
      if(newData){
          previousEvaluationDatatable(evaluationsData, setDetails)
          dispatch(clearResetBot())
      }      
    }, [newData])

  return (
    <NotapWrapper pageTitle={`Previous Evaluation History (${previousCertificateRequest?.name})`}>
      <div>
         {showDocumentCarousel && <DocumentCarousel certificateDetails={previousCertificateDetails}/>}
         {showEvaluationDetails && <EvaluationDetails/>}
         {showPrevCertificateDetails && <ViewCetrificateDetailsModal/>}
        {/* <CardSummary /> */}
        <button
          onClick={()=>{
            navigate(-1)
          }}
         className='btn btn-sm btn-primary mb-3'
        >
          <i style={{fontSize: '1rem'}} className="mdi mdi-arrow-left mr-1"></i>
          Go back to current evaluation
        </button>
        <DataTableWrapper 
        tableID="prevEvaluationTable" tableName='Evaluation'
        tableButtons={
          <ActionButtons/>
  } 
        >
        <thead>
            <tr>
              <th width={'20px'} data-orderable="false"></th>
              <th width={'16%'}>Role</th>
              <th width={'24%'}>User</th>
              <th >Comment</th>
              <th width={'16%'}>Created At</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </DataTableWrapper>
      </div>
    </NotapWrapper>
  )
}

function ActionButtons(){
  const dispatch = useDispatch()
  const {
        userData
    } = useSelector((state) => state.authData)
    const {
        certificateManagement:{certificateDetails},
        evaluationManagement: {showCommentRichTextForm, hasAddedEval, newData, evaluationsData}
    } = useSelector((state) => state.notapUser)
  return(
    <div style={{columnGap: '0.5rem'}} className='d-flex'>
        <button onClick={()=> {
          dispatch(showPrevCertificateDetailsFunc({modal: true}))
          }} className='btn btn-sm btn-outline-primary'>
          <i style={{fontSize: '1rem'}} className="mdi mdi-eye mr-1"></i>
          View Details
        </button>
      <button onClick={()=>{dispatch(showDocumentCarouselFunc({modal: true}))}} className='btn btn-sm btn-outline-primary'>
        <i style={{fontSize: '1rem'}} className="mdi mdi-folder-open mr-1"></i>
        View Documents
      </button>
    </div>
  )
}
